import { ApiGufGufsListRequest, GUF } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { getSearchKey } from "@/components/searchbox";
import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { KEY_ADDON_MAP, useRouterTableData } from "@/hooks/use-router-table-data";
import { useGufListQuery } from "@/queries/query-guf";

import { FilterWrapper } from "../../components/filter-wrapper";

import { GufEventTable } from "./components/guf-event-table";
import { GufFilters } from "./components/guf-filters";
import { gufInformation } from "./types";

export const columnDefinitions: ColumnDefinition<GUF>[] = gufInformation.map(
  ({ key, label }, index) => ({
    title: label,
    renderFunction: (row) =>
      renderDefault(row[key], index === 0 ? `/guf/startregistratie/${row.uuid}/` : undefined),
    width: "1fr",
  })
);

export function GufTable() {
  const {
    page,
    setPage,
    searchField: _searchField,
    searchString,
    setSearchField,
    setSearchString,
  } = useRouterTableData({ keyAddon: KEY_ADDON_MAP.GUF });
  const searchField =
    (_searchField as keyof ApiGufGufsListRequest | undefined) || getSearchKey(gufInformation[0]);
  const queryParams: ApiGufGufsListRequest = {
    page,
    ...(searchField ? { [searchField]: searchString } : {}),
  };
  const { data: gufList, isLoading } = useGufListQuery(queryParams);
  const paginationProps = useQueryPagination({
    queryResponse: gufList,
    page,
    setPage,
  });

  return (
    <>
      <FilterWrapper>
        <GufFilters {...{ searchField, searchString, setSearchField, setSearchString }} />
      </FilterWrapper>
      <TableOverview
        isLoading={isLoading}
        rowAccordion={({ uuid }: GUF) => {
          if (!uuid) return null;
          return <GufEventTable uuid={uuid} />;
        }}
        tableData={gufList?.results || []}
        columnDefinitions={columnDefinitions}
        paginationProps={paginationProps}
      />
    </>
  );
}
